/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrderedFileDtoFromJSON, OrderedFileDtoToJSON, } from './';
export function ChangePhotoOrderRequestFromJSON(json) {
    return ChangePhotoOrderRequestFromJSONTyped(json, false);
}
export function ChangePhotoOrderRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'orderedFiles': !exists(json, 'orderedFiles') ? undefined : (json['orderedFiles'] === null ? null : json['orderedFiles'].map(OrderedFileDtoFromJSON)),
    };
}
export function ChangePhotoOrderRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'orderedFiles': value.orderedFiles === undefined ? undefined : (value.orderedFiles === null ? null : value.orderedFiles.map(OrderedFileDtoToJSON)),
    };
}
